<template>
  <div slot="body">
    <bita-form ref="form">
      <div slot="body">
        <div class="row">
          <bita-input
            type="text"
            name="name"
            label="نام محصول"
            rules="required"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="form.name"
          />


          <!-- <bita-input
            type="text"
            name="second_name"
            label="نام دوم محصول"
            subtitle="عنوان لاتین"
            rules=""
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="form.second_name"
          /> -->

          <bita-input
            type="text"
            name="min_order_quantity"
            label="حداقل تعداد قابل سفارش"
            subtitle="مقدار صفر یا تهی به معنای غیر فعال بودن است"
            :validation-container-class="largeColWidth"
            :has-thousand-seprator="true"
            input-class="form-control"
            v-model="form.min_order_quantity"
          />
          <bita-input
            type="text"
            name="max_order_quantity"
            label="حداکثر تعداد قابل سفارش"
            subtitle="مقدار صفر یا تهی به معنای غیر فعال بودن است"
            :has-thousand-seprator="true"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="form.max_order_quantity"
          />
          <bita-treeselect
            name="category_id"
            ref="categoryTreeselect"
            label="گروه"
            rules="required"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="categories"
            data-text-field="name"
            data-value-field="id"
            v-model="form.category_id"
          />
          <bita-select
            name="brand_id"
            ref="brandSelect"
            label="برند"
            rules="required"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="brands"
            data-text-field="name"
            data-value-field="id"
            v-model="form.brand_id"
          />
          <!-- <bita-select
            name="measure_id"
            ref="measureSelect"
            label="واحد اندازه گیری"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="measures"
            data-text-field="name"
            data-value-field="id"
            v-model="form.measure_id"
          /> -->

          <!-- <bita-select
            name="is_recommendation"
            ref="recommendedSelect"
            label="پیشنهاد لحظه ای"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="[
              { id: 0, name: 'خیر' },
              { id: 1, name: 'بله' },
            ]"
            data-text-field="name"
            data-value-field="id"
            v-model="form.is_recommended"
          /> -->
          <!-- <bita-input
            type="number"
            name="coefficient"
            label="ضریب محصول"
            :has-thousand-seprator="true"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="form.coefficient"
            subtitle="تعداد محصول انتخابی در این عدد ضرب می شود"
          /> -->
          <bita-select
            name="active"
            ref="activeSelect"
            label="وضعیت"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="[
              { id: 0, name: 'غیر فعال' },
              { id: 1, name: 'فعال' },
            ]"
            data-text-field="name"
            data-value-field="id"
            v-model="form.active"
          />

          <hr />
          
          <div class="col-12 mb-5 border mx-3">
            <p style="font-size: 27px; color: #ff5400;" class="mt-2"> اطلاعات مربط به بلوک </p>
            
            <div class="row">

              <bita-input
                type="number"
                name="product_width"
                label="عرض محصول"
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="form.product_width"
              />

              <bita-input
                type="number"
                name="product_length"
                label="طول محصول"
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="form.product_length"
              />

              <bita-input
                type="number"
                name="product_thickness"
                label="ضخامت محصول"
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="form.product_thickness"
              />

              <bita-input
                type="number"
                name="volume_of_cubic_meters"
                label="حجم پالت (متر مکعب)"
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="form.volume_of_cubic_meters"
              />

              <bita-input
                type="number"
                name="volume_of_square_meters"
                label="حجم پالت (متر مربع)"
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="form.volume_of_square_meters"
              />

              <bita-input
                type="number"
                name="number_blocks_in_pallet"
                label="تعداد بلوک در هر پالت"
                :validation-container-class="largeColWidth"
                input-class="form-control"
                v-model="form.number_blocks_in_pallet"
              />

            </div>
          </div>

          <div class="col-12 mb-5 border mx-3">
            <p style="font-size: 27px; color: #ff5400;" class="mt-2"> اطلاعات مربط به چسب بلوک </p>
            
            <div class="row">
                <bita-input
                  type="number"
                  name="bag"
                  label=" بسته بندی کیسه بر حسب کیلوگرم"
                  :validation-container-class="largeColWidth"
                  input-class="form-control"
                  v-model="form.bag"
                />

                <bita-input
                  type="number"
                  name="glue_per_cubic_meter"
                  label="به ازای هر متر مکعب"
                  :validation-container-class="largeColWidth"
                  input-class="form-control"
                  v-model="form.glue_per_cubic_meter"
                />
            </div>
          </div>

          <!-- <bita-uploader
              name="uploader"
              label="تصویر راهنما"
              rules="size:50"
              ref="uploader"
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="form.help"
              :preview="true"
              :icon-url="form.help_file ? form.help_file.full_url : null"
            /> -->
          <bita-textarea
            name="short_description"
            ref="shortDescriptionTextarea"
            label="توضیح مختصر"
            rules=""
            validation-container-class="col-lg-12"
            input-class="form-control"
            v-model="form.short_description"
          />
          <bita-texteditor
            name="description"
            ref="descriptionTextarea"
            label="توضیح"
            rules=""
            validation-container-class="col-lg-12"
            input-class="form-control"
            v-model="form.description"
          />
        </div>
      </div>
    </bita-form>
  </div>
</template>
<script>
import {
  categoryApi,
  brandApi,
  productApi,
  measureApi,
} from "@/api/apiManagement";
export default {
  props: {
    title: String,
    isLoading: Boolean,
    largeColWidth: {
      default: "col-lg-3",
    },
    smallColWidth: {
      default: "col-lg-2",
    },
    product: {},
  },
  data() {
    return {
      form: {},
      categories: [],
      brands: [],
      measures: [],
    };
  },
  mounted() {
    var _this = this;
    Promise.all([
      categoryApi.getCategories(),
      brandApi.get(),
      measureApi.getMeasures(),
    ]).then((res) => {
      this.categories = res[0].data.entity;
      this.brands = res[1].data.entity;
      this.measures = res[2].data.entity;
    });
  },
  watch: {
    product: function (_data) {
      this.form = _data;
      // this.$refs.shortDescriptionTextarea.setInitialValue(
      //   _data.short_description
      // );
      this.$refs.descriptionTextarea.setInitialValue(_data.description);
    },
  },
  computed: {
    formRef() {
      return this.$refs.form;
    },
    isUpdateMode() {
      return this.form.id && this.form.id > 0;
    },
  },
  methods: {
    setInitialValue(_data) {
      this.form = _data;
      // this.$refs.shortDescriptionTextarea.setInitialValue(
      //   _data.short_description ? _data.short_description : ""
      // );
      this.$refs.descriptionTextarea.setInitialValue(
        _data.description ? _data.description : ""
      );
    },

    save() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$emit("is-loading", true);
            if (this.isUpdateMode) {
              productApi
                .updateProductInfo(this.form.id, this.$getFormData(this.form))
                .then((res) => {
                  this.$emit("on-update", this.form);
                  resolve(true);
                })
                .finally(() => {
                  this.$emit("is-loading", false);
                })
                .catch((err) => {
                  this.setErrors(err.response.data.errors);
                  reject(err);
                });
            } else {
              productApi
                .createProduct(this.$getFormData(this.form))
                .then((res) => {
                  this.form = res.data.entity;
                  this.$emit("on-update", this.form);
                  resolve(true);
                })
                .finally(() => {
                  this.$emit("is-loading", false);
                })
                .catch((err) => {
                  this.setErrors(err.response.data.errors);
                  reject(err);
                });
            }
          } else reject(false);
        });
      });
    },

    validate() {
      return this.$refs.form.validate();
    },

    setErrors(err) {
      this.$refs.form.setErrors(err);
    },

    reset() {
      this.form = {};
      this.$refs.categoryTreeselect.emptyKendo();
      this.$refs.brandSelect.emptyKendo();
      this.$refs.recommendedSelect.emptyKendo();
      this.$refs.activeSelect.emptyKendo();
      // this.$refs.shortDescriptionTextarea.reset();
      this.$refs.descriptionTextarea.reset();
      this.formRef.reset();
    },
  },
};
</script>
